import { useMemo } from 'react';

import clsx from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';

import { WrappedSelect } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';

export function LoadTypes() {
  const { control } = useFormContext<IForm>();

  const { serviceType, country_id, line } = useFormDataContext();

  const { t } = useAppTranslation(['common', 'demand']);

  const loadTypes = useMemo(
    () =>
      serviceType?.cargo_types.filter(
        ({ vehicle_types }) => vehicle_types?.length > 0
      ),
    [serviceType]
  );

  const isCleanCO = country_id === 1 && line?.line_filter === 'clean';

  return serviceType && loadTypes && loadTypes?.length > 0 ? (
    <Controller
      control={control}
      name="cargo_type_id"
      rules={{
        validate: (v) => {
          if (loadTypes.length > 1 && !v) return t('common:msg.required_field');
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <WrappedSelect
          isOnModal
          id="loadType"
          requiredMark
          {...field}
          label={t(isCleanCO ? 'common:riskType' : 'common:loadType')}
          error={error?.message}
          className={clsx(loadTypes.length <= 1 && 'hidden')}
        >
          <option hidden value="">
            {t('common:select_option')}
          </option>
          {loadTypes?.map(({ id, name }) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </WrappedSelect>
      )}
    />
  ) : null;
}
